import template from './breadcrumb.html';
import controller from './breadcrumb.controller.js';

let breadcrumbComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default breadcrumbComponent;



// WEBPACK FOOTER //
// ./src/app/common/breadcrumb/breadcrumb.component.js